import React from 'react';
import { Coin } from '@phosphor-icons/react';
import { cn } from '../../lib/utils';
interface CostPreviewLineProps {
  balance: number;
  cost?: number;
  className?: string;
}
/**
 * Inline cost preview shown next to the "Trimite ofertă" CTA.
 * Three visual tiers:
 *   - balance > 1: neutral, "Cost: 1 credit · Sold după: 49 credite"
 *   - balance === 1: warning lime, "Mai ai 1 credit. Trimiterea îl va consuma."
 *   - balance === 0: error red, "Nu ai credite suficiente"
 */
export function CostPreviewLine({
  balance,
  cost = 1,
  className
}: CostPreviewLineProps) {
  const after = balance - cost;
  const isZero = balance === 0;
  const isLast = balance === 1;
  return <div className={cn('flex items-center gap-2 text-xs px-3 py-2 rounded-md border', isZero ? 'bg-red-3/20 border-red-1 text-red-1' : isLast ? 'bg-lime-5 border-lime-4 text-lime-1' : 'bg-dark-3 border-dark-4 text-light-3', className)} data-id="element-53">
      <Coin size={14} weight={isZero || isLast ? 'fill' : 'regular'} className="shrink-0" data-id="element-54" />
      {isZero ? <span className="font-medium" data-id="element-55">
          Nu ai credite suficiente. Cumpără un pachet pentru a trimite.
        </span> : isLast ? <span data-id="element-56">
          Mai ai <span className="font-semibold" data-id="element-57">1 credit</span>. Trimiterea îl
          va consuma.
        </span> : <span data-id="element-58">
          Cost:{' '}
          <span className="font-semibold text-light-1" data-id="element-59">
            {cost} credit{cost === 1 ? '' : 'e'}
          </span>
          {' · '}
          Sold după trimitere:{' '}
          <span className="font-semibold text-light-1" data-id="element-60">{after} credite</span>
        </span>}
    </div>;
}